export const endpoints = {
  DATASET_LIST: "/datasets",
  DATASET_SHOW: "/datasets/:id",
};
